import { ResourceGraph } from './ResourceGraph';
import { ResponseWrapper } from './ResponseWrapper';
export function create(uri, response, resources, rootSelectors) {
    const safeResources = resources || new ResourceGraph();
    const safeSelectors = rootSelectors || [];
    class HydraResponse extends ResponseWrapper {
        constructor(requestedUri) {
            super(requestedUri, response.xhr);
        }
        get(identifier) {
            return safeResources.get(identifier);
        }
        get root() {
            return safeSelectors.reduce((resource, selector) => {
                if (!resource) {
                    resource = selector.selectRoot(safeResources, this);
                }
                return resource;
            }, null);
        }
        get length() {
            return Object.keys(safeResources).length;
        }
        ofType(classId) {
            return Object.values(safeResources).filter((res) => res.types.contains(classId));
        }
        [Symbol.iterator]() {
            return Object.values(safeResources)[Symbol.iterator]();
        }
    }
    return new HydraResponse(uri);
}
//# sourceMappingURL=HydraResponse.js.map